import { MaterialLayoutRenderer } from "@jsonforms/material-renderers";
import React from "react";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { rankWith, uiTypeIs } from "@jsonforms/core";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const Container = styled("div")(() => ({
  width: "100%",
  "& > .MuiGrid-container": {
    gap: "20px",
    flexWrap: "nowrap",
  },
}));

const VerticalLayoutRenderer = (props) => {
  const { uischema, schema, path, visible, renderers } = props;

  const layoutProps = {
    elements: uischema.elements,
    schema: schema,
    path: path,
    visible: visible,
    uischema: uischema,
    renderers: renderers,
    direction: "column"
  };

  return (
    <Container>
      <MaterialLayoutRenderer {...layoutProps} />
    </Container>
  );
};

export const VerticalLayoutTester = rankWith(1000, uiTypeIs("VerticalLayout"));

export default withJsonFormsLayoutProps(VerticalLayoutRenderer);
